<template>
    <base-component>
        <template slot="form">
            <audit-search-form :fetch="fetchData" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card class="flex-fill flex-shrink-0">
                <pagination :pageSize="this.pageSize" :offset="offset" :listLength="auditData.length" :setOffset="setOffset"/>
                <b-table :items="auditData" :fields="fields" class="table-borderless" striped small show-empty>
                    <template slot="dateTime" slot-scope="row">
                        {{ $d(new Date(row.item.dateTime), 'long') }}
                    </template>
                    <template slot="success" slot-scope="row">
                        {{ row.item.success ? $t('audit.yes') : $t('audit.no') }}
                    </template>
                    <template slot="empty">
                        <div class="text-center">
                            {{ $t('general.noData') }}
                        </div>
                    </template>
                </b-table>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */

const AuditSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/audit/AuditSearchForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'Audit',
    components: {
        AuditSearchForm,
        Pagination
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            auditData: [],
            pageSize: 20,
            offset: 0
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading;
        },
        fields() {
            return [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'dateTime', label: this.$t('audit.dateTime'), sortable: true },
                { key: 'sysEvent', label: this.$t('audit.event'), sortable: true },
                { key: 'sysObject', label: this.$t('audit.sysObject'), sortable: true },
                { key: 'subject', label: this.$t('audit.subject'), sortable: true },
                { key: 'success', label: this.$t('audit.success'), sortable: true }
            ]
        }
    },
    methods: {
        fetchData(formData) {
            this.hideAlert();

            if (this.offset === 0)
                formData.dateTimeEnd = formData.dateTimeEndForm;

            const onSuccess = response => {
                this.auditData = response;

                if (this.offset !== 0)
                    return;
                
                if (this.auditData.length > 0 && this.auditData[0] != null) {
                    formData.dateTimeEnd = new Date(this.auditData[0].dateTime);
                }
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.audit.get,
                formData, 
                onSuccess, 
                this.displayAlert);
        },
        setOffset(newValue) {
            this.offset = newValue;
        },
        hideAlert() {
            this.showAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            debugger;
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        }
    }
}
</script>
